import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';

interface IntakeFormStepperProps {
  steps: string[];
  activeStep: number;
}

export const IntakeFormStepper: React.FC<IntakeFormStepperProps> = ({
  steps,
  activeStep,
}) => {
  return (
    <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};